var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('t-breadcrumbs',{staticClass:"t-breadcrumbs--page",attrs:{"items":_vm.breadcrumbs}}),_vm._v(" "),_c('jetton-info',_vm._b({attrs:{"address":_vm.address,"imageTA":_vm.imageTA}},'jetton-info',_vm.jettonProps,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }